import { Configuration } from './types';

/**
 * Internal UAT environment configuration.
 * This points at the UAT environment (i.e. all services referenced below are running/hosted in the UAT environment).
 */
export const config: Partial<Configuration> = {
  portalApi: 'https://api.uat-gv.eca.uat.portal.genvis.com/v1',
  mapbox: {
    token: 'pk.eyJ1IjoiZ2VudmlzLW1hbml0b2JhIiwiYSI6ImNtYmVpY2NqazAybm4yaXNoaWlhYXk4a3AifQ.MdoLKim7-5ipgGyEYyDkGg',
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://uat.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://uat.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  webTemplateStyleSheetUrl: 'https://uat.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  environment: 'uat-gv',
};
